import Device from "../../../devices/device";

export const getDeviceCategory = () => {
  const { config: { device_category = null} = {}} = Device.getDevice();

  return device_category;
}

export const getDevicePlatform = () => {
  const device = Device.getDevice();
  const platform = device.getPlatform();

  return platform;
}


// WEBPACK FOOTER //
// ./src/components/Focus/utils-to-devices/utils-device-category.ts